import React from 'react';
import styled, { keyframes } from 'styled-components';
import { tada } from 'react-animations';

const tadaAnimation = keyframes`${tada}`;

const SadDiv = styled.div`
  animation: 1s ${tadaAnimation};
  margin: 0 auto;
  font-size: 1.5em;
`;

export default class ErrorText extends React.Component {
  render() {
    return <SadDiv>☹️</SadDiv>;
  }
}




// WEBPACK FOOTER //
// ./src/components/ErrorText.js